import React, { Component } from 'react';
import * as Sentry from '@sentry/react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
    Sentry.captureException(error, { contexts: { react: { componentStack: errorInfo.componentStack } } });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="tw-max-w-2xl tw-mx-auto tw-px-4 tw-py-20 tw-text-center">
          <div className="tw-text-6xl tw-mb-4" style={{ opacity: 0.25 }}>&#9888;</div>
          <h1 className="tw-text-2xl tw-font-bold tw-text-[#1a1a1a] dark:tw-text-white tw-mb-2 tw-m-0">Something Went Wrong</h1>
          <p className="tw-text-sm tw-text-[#888] dark:tw-text-[#666] tw-mb-8 tw-m-0">
            An unexpected error occurred. Please try refreshing the page.
          </p>
          <div className="tw-flex tw-justify-center tw-gap-3 tw-flex-wrap">
            <button
              onClick={function() { window.location.reload(); }}
              className="tw-px-5 tw-py-2.5 tw-rounded-lg tw-text-sm tw-font-semibold tw-text-white tw-border-none tw-cursor-pointer tw-transition-colors"
              style={{ backgroundColor: '#b8860b' }}
            >
              Refresh Page
            </button>
            <button
              onClick={function() { window.location.href = '/'; }}
              className="tw-px-5 tw-py-2.5 tw-rounded-lg tw-text-sm tw-font-semibold tw-border tw-cursor-pointer tw-transition-colors tw-text-[#888] dark:tw-text-[#aaa] tw-border-[#e0e0e0] dark:tw-border-[#333] tw-bg-transparent"
            >
              Go Home
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
